export default __webpack_public_path__ + "static/media/Technical_PM_MBridi.4a0785f3.pdf";